<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-if="motivo">{{ motivo.nome }}</dd>
  </div>
</template>

<script>
import MotivoService from "../../../../domain/atendimento/MotivoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "view-c-protocolo-motivo",
  props: {
    label: String,
    value: String
  },
  asyncComputed: {
    motivo() {
      const motivoService = new MotivoService(this.$http);
      return motivoService
        .getMotivo()
        .then(result => result.find(motivo => this.value == motivo.id))
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/Motivo.vue